import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { MergeModalItem } from './mergeModal.types';
import { Warning } from './mergeModal.styles';

export type ConfirmationProps = {
  fromItems: MergeModalItem[];
  targetItem: MergeModalItem;
  children: string;
};

const Confirmation = ({ fromItems, targetItem, children }: ConfirmationProps) => {
  const lastItem = fromItems[fromItems.length - 1];
  let items = fromItems
    .slice(0, fromItems.length - 1)
    .map<React.ReactNode>((i) => <b key={i.label}>{i.label}</b>);
  if (items.length) {
    items = items.reduce((prev, curr) => [prev, ', ', curr]) as React.ReactNode[];
  }

  return (
    <>
      <Text14 themeColor={ThemeColorType.gray}>
        <TranslateWithComponents
          replaceComponents={{
            items: <>{items}</>,
            lastItem: <b>{lastItem.label}</b>,
            target: <b>{targetItem.label}</b>,
          }}>
          {children}
        </TranslateWithComponents>
      </Text14>
      <Warning>{gettext('Warning: this cannot be undone')}</Warning>
    </>
  );
};

export default Confirmation;
